import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Question } from 'src/app/shared/models/questionnaire.model';
import WaveSurfer from 'wavesurfer.js';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'app-view-chapter-question',
    templateUrl: './view-chapter-question.component.html',
    styleUrl: './view-chapter-question.component.scss',
    standalone: false
})
export class ViewChapterQuestionComponent implements OnChanges {
	@Input() report: boolean = false;
	@Input() question!: Question;
	@Input() question_length!: number;
	@Input() question_index!: number;
	@Input() lang_code!: string;
	@Input() chapter_name!: string | null;
	@Input() chapter_index!: number;
	@Input() questionID!: string;
	@Input() question_summary: boolean = false;

	sanitizedContent: any;
	currentAction: any;
	currentQuestionSubtitle = '';

	wave: WaveSurfer | null = null;
	audioLoading = true;

	selectedOptions: any[] = [];
	selectedRangeOption: any;
	record_timer = 0;
	alert_before = 0;
	
	timeLimitSubscription!: Subscription;
	isRecording = false;
	isRecorded = false;

	safeUrl!: SafeResourceUrl;

	constructor(private sanitizer: DomSanitizer) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['question']) {
			if (this.question.body.question && this.question.body.question != '<p></p>') {
				this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.question.body.question);
			} else {
				this.sanitizedContent = null;
			}

			if (this.question.body.link_url) {
				this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.question.body.link_url);
			}
	
			this.hanldeResponse();
		}
	}

	counter(length: number) {
		return Array.from({ length }, (_, i) => i + 1);
  }

	hanldeResponse() {
    switch (this.question.response.response_type) {
      case 'RANGE':
        this.currentAction = 'SELECT_AN_ANSWER';
				if (this.report) {
					this.selectedRangeOption = this.question.answer!.answer.response_range;
				}
        this.currentQuestionSubtitle = '';
        break;
      case 'SELECT':
        this.currentAction = this.question.response.response_select?.multi_select ? 'MULTI_SELECT' : 'SINGLE_SELECT';
				if (this.report) {
					this.selectedOptions = this.question.answer!.answer.response_select!.response_selected;
				}
        this.currentQuestionSubtitle = '';
        break;
      case 'VISUAL':
        this.currentAction = '';
        this.currentQuestionSubtitle = '';
        break;
      case 'VOICE':
        this.currentAction = 'RECORD_TITLE';
        this.currentQuestionSubtitle = 'RECORD_SUB_TITLE';
				if (this.question.response.response_voice) {
					this.alert_before = this.question.response.response_voice.alert_before;
					this.record_timer = this.question.response.response_voice.record_sec;
					this.timeLimitSubscription = timer(1000, 1000).subscribe(() => {
						if (this.alert_before > 0) {
							this.alert_before--;
						}

						if (this.alert_before === 0) {
							this.timeLimitSubscription.unsubscribe();
						}

					});
				}
        break;
    }
  }

	record() {
		this.isRecording = true;
		this.timeLimitSubscription = timer(1000, 1000).subscribe(() => {
			if (this.record_timer > 0) {
				this.record_timer--;
			} else {
				this.isRecording = false;
				this.isRecorded = true;
			}
		});
	}

	stopRecording() {
		this.timeLimitSubscription.unsubscribe();
		this.record_timer = 0;
		this.isRecording = false;
		this.isRecorded = true;
	}

	formatTime(seconds: number): string {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
	}

	generateWaveform(): void {
    Promise.resolve(null).then(() => {
      this.wave = WaveSurfer.create({
        container: '#waveform',
        waveColor: '#dfdfdf',
        progressColor: '#5b7ffc',
        cursorColor: '#5b7ffc',
        interact: false
      });
      this.wave.on('ready', () => {
        this.audioLoading = false;
        this.wave?.play();
      });
    });
  }

  getNumbers(startNumber: number, endNumber: number): number[] {
    return Array(endNumber - startNumber + 1).fill(0).map((_, index) => startNumber + index);
  }

	onSelectResponseChange($event: any, selectedOption: any) {
    if (this.question.response.response_select?.multi_select) {
      if ($event.target.checked) {
        this.selectedOptions.push(selectedOption);
      } else {
        const index = this.selectedOptions.indexOf(selectedOption);
        if (index !== -1) {
          this.selectedOptions.splice(index, 1);
        }
      }
    } else {
			if (this.selectedOptions.length > 0) {
				this.selectedOptions[0] = selectedOption;
			} else {
				this.selectedOptions.push(selectedOption);
			}
    }
  }

	checkValueInSelectedOptionList(option: any) : boolean {
    return this.selectedOptions.find(item => item.label === option.label);
  }

	onRangeOptionSelected($event: any, count: any) {
    this.selectedRangeOption = count;
  }
}
